import { render, staticRenderFns } from "./BasicForm.vue?vue&type=template&id=715493a2&scoped=true"
import script from "./BasicForm.vue?vue&type=script&lang=js"
export * from "./BasicForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "715493a2",
  null
  
)

export default component.exports